import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import zxcvbn from 'zxcvbn';
const PASSWORD_COMPLEXITY = {
    0: {
        text: 'Too Weak',
        classNames: 'bg-red-700 w-1/5',
        localizationSlug: 'TOO_WEAK',
    },
    1: { text: 'Weak', classNames: 'bg-red-400 w-2/5', localizationSlug: 'WEAK' },
    2: {
        text: 'Fair',
        classNames: 'bg-green-300 w-3/5',
        localizationSlug: 'FAIR',
    },
    3: {
        text: 'Good',
        classNames: 'bg-green-500 w-4/5',
        localizationSlug: 'GOOD',
    },
    4: {
        text: 'Strong',
        classNames: 'bg-green-700 w-5/5',
        localizationSlug: 'STRONG',
    },
};
export default function PasswordComplexity({ password }) {
    const [passwordStatus, setPasswordStatus] = useState({});
    const { t } = useTranslation();
    const getPasswordStatus = () => {
        const { score } = zxcvbn(password);
        setPasswordStatus(PASSWORD_COMPLEXITY[score]);
    };
    useEffect(() => {
        getPasswordStatus();
    }, [password]);
    return (React.createElement("div", { className: "pb-2" },
        React.createElement("div", { className: "font-semibold pb-1" }, `${t('PASSWORD_COMPLEXITY_WITH_STATUS')} : ${t(passwordStatus === null || passwordStatus === void 0 ? void 0 : passwordStatus.localizationSlug)}`),
        React.createElement("div", { className: "w-full bg-gray-200 rounded-full" },
            React.createElement("div", { className: `text-xs font-medium text-white text-center p-0.5 leading-none rounded-full ${passwordStatus === null || passwordStatus === void 0 ? void 0 : passwordStatus.classNames}` }))));
}
